import { render } from "./hotelSlider.vue?vue&type=template&id=1173c422&scoped=true"
import script from "./hotelSlider.vue?vue&type=script&lang=js"
export * from "./hotelSlider.vue?vue&type=script&lang=js"

import "./hotelSlider.vue?vue&type=style&index=0&id=1173c422&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1173c422"]])

export default __exports__